// @flow

import { type PendingIncomingPayment } from './types';

export function getRedirectUrlForPendingPayment(incomingPayment: PendingIncomingPayment): ?string {
  return incomingPayment['redirect_url_for_pending_payment'];
}
